import React, { PureComponent } from "react"

import Picture from "./Picture"

import { env, utils } from "../constants"



/* Component Payout */
class Payout extends PureComponent {

    render = () => {

        const { game, currency } = this.props
        const { min, maxPerfectPair, maxTwentyOne, maxBust, maxCrazySeven } = game

        return (
            <div className="payout-container">

                <div className="payout-inner">

                    <div className="payout center">
                        <p className="payout-main-text">Blackjack pays 3 to 2 6 cards win</p>
                    </div>

                    <div className="payout center">
                        <p className="payout-main-text">Dealer must draw to 16 and stand on all 17's</p>
                    </div>

                    <div className="payout additional">

                        <div className="payout-head">{utils.translate("BLACKJACK")}</div>

                        <div className="payout-box">
                            <div className="payout-name">{utils.translate("BEST HAND")}</div>
                            <div className="payout-value">1:1</div>
                        </div>
                        <div className="payout-box">
                            <div className="payout-name">{utils.translate("INSURANCE")}</div>
                            <div className="payout-value">2:1</div>
                        </div>
                        <div className="payout-box">
                            <div className="payout-name">{utils.translate("BLACKJACK")}</div>
                            <div className="payout-value">3:2</div>
                        </div>
                    </div>

                    {/* PERFECT PAIRS PAYOUTS */}
                    <div className="payout additional">

                        <div className="payout-head">{utils.translate("PERFECT PAIR")} <div className="payout-rate">{utils.getWithCurrency(min, currency)} - {utils.getWithCurrency(maxPerfectPair, currency)}</div></div>

                        <div className="payout-box">
                            <div className="payout-name">{utils.translate("PERFECT PAIR")}</div>
                            <div className="payout-combination">
                                <div className="payout-combination-box">
                                    <div className="payout-combination-text">K</div>
                                    <Picture src={`${env.mediapoint}/images/suits/diamond-red.png`} alt="Clubs" />
                                </div>
                                <div className="payout-combination-box">
                                    <div className="payout-combination-text">K</div>
                                    <Picture src={`${env.mediapoint}/images/suits/diamond-red.png`} alt="Diamond" />
                                </div>
                            </div>
                            <div className="payout-value">25:1</div>
                        </div>

                        <div className="payout-box">
                            <div className="payout-name">{utils.translate("COLOURED PAIR")}</div>
                            <div className="payout-combination">
                                <div className="payout-combination-box">
                                    <div className="payout-combination-text">K</div>
                                    <Picture src={`${env.mediapoint}/images/suits/heart-red.png`} alt="Clubs" />
                                </div>
                                <div className="payout-combination-box">
                                    <div className="payout-combination-text">A</div>
                                    <Picture src={`${env.mediapoint}/images/suits/diamond-red.png`} alt="Diamond" />
                                </div>
                            </div>
                            <div className="payout-value">12:1</div>
                        </div>

                        <div className="payout-box">
                            <div className="payout-name">{utils.translate("MIXED PAIR")}</div>
                            <div className="payout-combination">
                                <div className="payout-combination-box">
                                    <div className="payout-combination-text">Q</div>
                                    <Picture src={`${env.mediapoint}/images/suits/clubs.png`} alt="Clubs" />
                                </div>
                                <div className="payout-combination-box">
                                    <div className="payout-combination-text">Q</div>
                                    <Picture src={`${env.mediapoint}/images/suits/heart-red.png`} alt="Diamond" />
                                </div>
                            </div>
                            <div className="payout-value">6:1</div>
                        </div>

                    </div>

                    {/* 21 + 3 PAYOUTS */}
                    <div className="payout additional">

                        <div className="payout-head">{utils.translate("21+3")} <div className="payout-rate">{utils.getWithCurrency(min, currency)} - {utils.getWithCurrency(maxTwentyOne, currency)}</div></div>

                        <div className="payout-box">
                            <div className="payout-name">{utils.translate("SUITED TRIPS")}</div>
                            <div className="payout-combination">
                                <div className="payout-combination-box">
                                    <div className="payout-combination-text">A</div>
                                    <Picture src={`${env.mediapoint}/images/suits/spades.png`} alt="Heart" />
                                </div>
                                <div className="payout-combination-box">
                                    <div className="payout-combination-text">A</div>
                                    <Picture src={`${env.mediapoint}/images/suits/spades.png`} alt="Heart" />
                                </div>
                                <div className="payout-combination-box">
                                    <div className="payout-combination-text">A</div>
                                    <Picture src={`${env.mediapoint}/images/suits/spades.png`} alt="Heart" />
                                </div>
                            </div>
                            <div className="payout-value">100:1</div>
                        </div>

                        <div className="payout-box">
                            <div className="payout-name">{utils.translate("STRAIGHT FLUSH")}</div>
                            <div className="payout-combination">
                                <div className="payout-combination-box">
                                    <div className="payout-combination-text">7</div>
                                    <Picture src={`${env.mediapoint}/images/suits/heart-red.png`} alt="Heart" />
                                </div>
                                <div className="payout-combination-box">
                                    <div className="payout-combination-text">8</div>
                                    <Picture src={`${env.mediapoint}/images/suits/heart-red.png`} alt="Heart" />
                                </div>
                                <div className="payout-combination-box">
                                    <div className="payout-combination-text">9</div>
                                    <Picture src={`${env.mediapoint}/images/suits/heart-red.png`} alt="Heart" />
                                </div>
                            </div>
                            <div className="payout-value">40:1</div>
                        </div>

                        <div className="payout-box">
                            <div className="payout-name">{utils.translate("THREE OF A KIND")}</div>
                            <div className="payout-combination">
                                <div className="payout-combination-box">
                                    <div className="payout-combination-text">Q</div>
                                    <Picture src={`${env.mediapoint}/images/suits/clubs.png`} alt="Heart" />
                                </div>
                                <div className="payout-combination-box">
                                    <div className="payout-combination-text">Q</div>
                                    <Picture src={`${env.mediapoint}/images/suits/diamond-red.png`} alt="Heart" />
                                </div>
                                <div className="payout-combination-box">
                                    <div className="payout-combination-text">Q</div>
                                    <Picture src={`${env.mediapoint}/images/suits/spades.png`} alt="Heart" />
                                </div>
                            </div>
                            <div className="payout-value">30:1</div>
                        </div>


                        <div className="payout-box">
                            <div className="payout-name">{utils.translate("STRAIGHT")}</div>
                            <div className="payout-combination">
                                <div className="payout-combination-box">
                                    <div className="payout-combination-text">3</div>
                                    <Picture src={`${env.mediapoint}/images/suits/spades.png`} alt="Heart" />
                                </div>
                                <div className="payout-combination-box">
                                    <div className="payout-combination-text">4</div>
                                    <Picture src={`${env.mediapoint}/images/suits/diamond-red.png`} alt="Heart" />
                                </div>
                                <div className="payout-combination-box">
                                    <div className="payout-combination-text">5</div>
                                    <Picture src={`${env.mediapoint}/images/suits/heart-red.png`} alt="Heart" />
                                </div>
                            </div>
                            <div className="payout-value">10:1</div>
                        </div>

                        <div className="payout-box">
                            <div className="payout-name">{utils.translate("FLUSH")}</div>
                            <div className="payout-combination">
                                <div className="payout-combination-box">
                                    <div className="payout-combination-text">3</div>
                                    <Picture src={`${env.mediapoint}/images/suits/heart-red.png`} alt="Heart" />
                                </div>
                                <div className="payout-combination-box">
                                    <div className="payout-combination-text">10</div>
                                    <Picture src={`${env.mediapoint}/images/suits/heart-red.png`} alt="Heart" />
                                </div>
                                <div className="payout-combination-box">
                                    <div className="payout-combination-text">Q</div>
                                    <Picture src={`${env.mediapoint}/images/suits/heart-red.png`} alt="Heart" />
                                </div>
                            </div>
                            <div className="payout-value">5:1</div>
                        </div>

                    </div>

                    {/* BUST PAYOUTS */}
                    <div className="payout additional">

                        <div className="payout-head">{utils.translate("BUST")} <div className="payout-rate">{utils.getWithCurrency(min, currency)} - {utils.getWithCurrency(maxBust, currency)}</div></div>

                        <div className="payout-box">
                            <div className="payout-name">{utils.translate("BUST WITH 8+ CARDS")}</div>
                            <div className="payout-value">250:1</div>
                        </div>

                        <div className="payout-box">
                            <div className="payout-name">{utils.translate("BUST WITH 7 CARDS")}</div>
                            <div className="payout-value">100:1</div>
                        </div>

                        <div className="payout-box">
                            <div className="payout-name">{utils.translate("BUST WITH 6 CARDS")}</div>
                            <div className="payout-value">50:1</div>
                        </div>

                        <div className="payout-box">
                            <div className="payout-name">{utils.translate("BUST WITH 5 CARDS")}</div>
                            <div className="payout-value">9:1</div>
                        </div>

                        <div className="payout-box">
                            <div className="payout-name">{utils.translate("BUST WITH 4 CARDS")}</div>
                            <div className="payout-value">2:1</div>
                        </div>

                        <div className="payout-box">
                            <div className="payout-name">{utils.translate("BUST WITH 3 CARDS")}</div>
                            <div className="payout-value">1:1</div>
                        </div>

                    </div>

                    {/* CRAZY SEVEN PAYOUTS */}
                    <div className="payout additional">

                        <div className="payout-head">{utils.translate("CRAZY 7")} <div className="payout-rate">{utils.getWithCurrency(min, currency)} - {utils.getWithCurrency(maxCrazySeven, currency)}</div></div>

                        <div className="payout-box">
                            <div className="payout-name">{utils.translate("7-7-7 SUITED")}</div>
                            <div className="payout-combination">
                                <div className="payout-combination-box">
                                    <div className="payout-combination-text">7</div>
                                    <Picture src={`${env.mediapoint}/images/suits/heart-red.png`} alt="Heart" />
                                </div>
                                <div className="payout-combination-box">
                                    <div className="payout-combination-text">7</div>
                                    <Picture src={`${env.mediapoint}/images/suits/heart-red.png`} alt="Heart" />
                                </div>
                                <div className="payout-combination-box">
                                    <div className="payout-combination-text">7</div>
                                    <Picture src={`${env.mediapoint}/images/suits/heart-red.png`} alt="Heart" />
                                </div>
                            </div>
                            <div className="payout-value">2000:1</div>
                        </div>

                        <div className="payout-box">
                            <div className="payout-name">{utils.translate("7-7-7")}</div>
                            <div className="payout-combination">
                                <div className="payout-combination-box">
                                    <div className="payout-combination-text">7</div>
                                    <Picture src={`${env.mediapoint}/images/suits/clubs.png`} alt="Clubs" />
                                </div>
                                <div className="payout-combination-box">
                                    <div className="payout-combination-text">7</div>
                                    <Picture src={`${env.mediapoint}/images/suits/diamond-red.png`} alt="Diamond" />
                                </div>
                                <div className="payout-combination-box">
                                    <div className="payout-combination-text">7</div>
                                    <Picture src={`${env.mediapoint}/images/suits/spades.png`} alt="Spades" />
                                </div>
                            </div>
                            <div className="payout-value">500:1</div>
                        </div>

                        <div className="payout-box">
                            <div className="payout-name">{utils.translate("7-7 SUITED")}</div>
                            <div className="payout-combination">
                                <div className="payout-combination-box">
                                    <div className="payout-combination-text">7</div>
                                    <Picture src={`${env.mediapoint}/images/suits/diamond-red.png`} alt="Diamond" />
                                </div>
                                <div className="payout-combination-box">
                                    <div className="payout-combination-text">7</div>
                                    <Picture src={`${env.mediapoint}/images/suits/diamond-red.png`} alt="Diamond" />
                                </div>
                            </div>
                            <div className="payout-value">150:1</div>
                        </div>

                        <div className="payout-box">
                            <div className="payout-name">{utils.translate("7-7")}</div>
                            <div className="payout-combination">
                                <div className="payout-combination-box">
                                    <div className="payout-combination-text">7</div>
                                    <Picture src={`${env.mediapoint}/images/suits/spades.png`} alt="Spades" />
                                </div>
                                <div className="payout-combination-box">
                                    <div className="payout-combination-text">7</div>
                                    <Picture src={`${env.mediapoint}/images/suits/heart-red.png`} alt="Heart" />
                                </div>
                            </div>
                            <div className="payout-value">25:1</div>
                        </div>

                        <div className="payout-box">
                            <div className="payout-name">{utils.translate("7")}</div>
                            <div className="payout-combination">
                                <div className="payout-combination-box">
                                    <div className="payout-combination-text">7</div>
                                    <Picture src={`${env.mediapoint}/images/suits/clubs.png`} alt="Spades" />
                                </div>
                            </div>
                            <div className="payout-value">5:1</div>
                        </div>

                    </div>

                </div>

            </div>
        )
    }

}

export default Payout